<template>
  <div>
    <h2>{{ $t(menuName) }}</h2>
    <keep-alive>
      <em-breadcrumb ref="emBreadCrumb" v-bind:breadcrumbItems="breadcrumbItems"></em-breadcrumb>
    </keep-alive>
  </div>
</template>

<script>
import EmBreadcrumb from "@/components/em/EmViewTitle/EmBreadcrumb";

export default {
  name: "emViewTitle",
  components: {EmBreadcrumb},
  props: {
    crudState: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      moduleName: "",
      menuName: "",
      breadcrumbItems: []
    };
  },
  methods: {
    //取页面的title与导航信息
    getMenuTitleData() {
      let actionName = "";
      let actionParam = {};
      //有this.$route.query.menuId就按menuId查
      if (this.$route.query.menuId) {
        actionName = "api/get";
        actionParam = {
          url:
              process.env.VUE_APP_EM_ADMIN_URL +
              "/emMenu/menuTitleData/" +
              this.$route.query.menuId
        };
      }
      // 没有就按path+crudState查，crudState可为空
      else if (this.$route.path) {
        console.log("query menuTitleData by path:" + this.$route.path)
        actionName = "api/post";
        actionParam = {
          url: process.env.VUE_APP_EM_ADMIN_URL + "/emMenu/menuTitleData",
          data: {
            url: this.$route.path,
            crudState: this.crudState
          }
        };
      }
      if (actionName !== "") {
        this.$store
            .dispatch(actionName, actionParam, {root: true})
            .then(menuTitleData => {
                // todo : api中get返回的是response.data而post则直接返回response，所以需要再取一下data，不知道这样区分又何必要。将来看怎么统一一下
                if (actionName === "api/post") {
                    menuTitleData = menuTitleData.data
                }
                this.breadcrumbItems = menuTitleData.breadcrumbItems;
                this.moduleName = menuTitleData.moduleName;
                this.menuName = menuTitleData.menuName;
                this.$emit('gotMenuName', this.menuName);
                this.$store.commit('routeStore/setCurrentPageTitle', this.menuName);
            });
      }
    },
      goBack() {
          this.$refs.emBreadCrumb.goBack();
      },
      retrieveForMaxFileSettings() {
          // console.log("log >>> path【%s】 em-view-title mounted",this.$route.path)
          this.$store.dispatch("api/get", {
              url: (process.env.VUE_APP_EM_ADMIN_URL + "/businessModule/maxFileSettings")
          }, {root: true})
              .then(function (data) {
                  localStorage.maxFileSettings = JSON.stringify(data)
              })
      }
  },
  mounted() {
      this.getMenuTitleData();
      // 获取每个模块允许上传的附件大小
      this.retrieveForMaxFileSettings()
  },
    watch: {
     '$route.params.code'(val) {
         if (val) {
             this.getMenuTitleData();
         }
      },
    }
};
</script>
